import "./style.css";
import loyalty_page from "./views/loyalty_panel.handlebars"


const cookieName = "rcio-loyalty-cust";
const CLIENT_ID = "nu2eh5roqoej8xj8d4xlo5elbbhgftv";

function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, expires) {
  const options = {
    path: "/",
    "max-age": expires,
    secure: true,
  };

  let updatedCookie =
    encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }
  document.cookie = updatedCookie;
}

function deleteCookie(name) {
  setCookie(name, "", {
    'max-age': -1
  })
}

const customerJWT = (apiAccountClientId) => {
  let resource = `/customer/current.jwt?app_client_id=${apiAccountClientId}`;
  return fetch(resource)
    .then((response) => {
      if (response.status === 200) {
        return response.text();
      } else {
        return null;
      }
    })
    .catch((error) => {return null;});
};


const getCustomer = async () => {
  try {
    
    const cookie = getCookie(cookieName);
    const loginState = window.localStorage.getItem('rcio-login');

    if (!cookie || cookie !== loginState) {
      window.localStorage.removeItem('rcio-loyalty');
      const clientId = CLIENT_ID;
      const storeId = store_hash;
      if (!clientId || !storeId) {
        console.error("Loyalty Client ID or Store ID is missing!");
        return null;
      }
      const customerToken = await customerJWT(clientId);

      const response = await fetch(
        `https://loyalty.rcio.app/v1/bc/gc?jwt=${customerToken}&store=${storeId}`, {cache: 'no-cache'}
      );
      if (response.ok) {
        const loyalty = await response.json();
        window.localStorage.setItem('rcio-loyalty', JSON.stringify(loyalty));
        setCookie(cookieName, loginState, 15*60)
        return loyalty;
      }
      return null;
    } else {
      const loyalty = window.localStorage.getItem('rcio-loyalty');
      if (loyalty) {
        return JSON.parse(loyalty);
      } else {
        deleteCookie(cookieName);
        return null;
      }

    }
  } catch (e) {
    console.error(e);
    deleteCookie(cookieName)
    window.localStorage.removeItem('rcio-loyalty');
    return null;
  }
};

const loyaltyInit = async (loadHTMLPage = true) => {

  if (!store_hash) {
    console.error('Setting Store Hash is missing!');
    return null;
  }

  if (loadHTMLPage) {
    const spinnerHTML = `<div class="rc-loyalty-center-full"><br><br><br><br><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>`;
    const el = document.getElementById(`rcio-loyalty-page`);
    if (el) el.innerHTML = spinnerHTML;
  }
  

  const programData = await getCustomer();
  console.log(programData)

  if (loadHTMLPage) loadPage(programData.sc, programData.cust, programData.rewards);

  if (programData.cust) {
    // points available
    setPoints('pa', programData.cust.pa)
    // points pending
    setPoints('pp', programData.cust.pp)
    // points lifetime
    setPoints('pl', programData.cust.pl)
    // points spent
    setPoints('ps', programData.cust.ps)
  }
};

function setPoints(type, value = 0) {
  const el = document.getElementsByClassName(`rcio-loyalty-${type}`);
  if (el && el.length > 0) {
    const pointValue = value ? value.toLocaleString("en-us") : 0;
    for (const e of el) e.innerHTML = pointValue;
  }
}   

window.rcioLoyaltyGetReward = async (points, type) => {

  try {
    const el = document.getElementById(`rc-loyalty-reward-${type.toLowerCase()}-${points}`);
    const btn = document.getElementById(`rc-loyalty-reward-${type.toLowerCase()}-${points}-button`);

    if (type === "COUPON") {
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = `<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>`;
      }
      const customerToken = await customerJWT(CLIENT_ID);
      if (!customerToken) window.location.replace("/login.php");

      const response = await fetch(
        `https://loyalty.rcio.app/v1/bc/gr?jwt=${customerToken}&type=${type}&points=${points}`, {cache: 'no-cache'}
      );
      
      if (response.ok) {

        const coupon = await response.json();
        if (coupon && coupon.coupon_code) {
          if (el) el.innerHTML = `<p>Coupon <span onclick="rcCopyToClipboard('${coupon.coupon_code}',this)" style="text-decoration: underline;" title="Click to copy">${coupon.coupon_code}</span> created!  Click the code to copy it!</p>`;
          deleteCookie(cookieName);
          loyaltyInit(false);
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = `Get Rewarded`;
          }
          return true;
        } 
        
      }
      if (btn) {
        btn.innerHTML = `Ooops!`;
      }
      if (el) el.innerHTML = `Something went wrong!  Please clear your cache and try again!<br>`
      
    }

     
  } catch (e) {
    console.error(e);
  }

}

window.rcCopyToClipboard = async (textValue, el) => {

  try {
    await navigator.clipboard.writeText(textValue);
    if (el) {
      el.innerHTML = "Copied!"
      setTimeout(()=> {el.innerHTML = textValue;}, 1000)
    }
    
  } catch (e) {
    console.error(e);
  }
}

function loadPage(options, customer, rewards) {

  const el = document.getElementById(`rcio-loyalty-page`);
  if (!el) return null;

  let store_config = options;
  for (let t of store_config.tier) {
    const pointsEarned = customer && customer[t.points_type] ? customer[t.points_type] : -1;
    t.earned = t.points < pointsEarned;
  }
  el.innerHTML = loyalty_page({config: store_config, customer: customer, rewards: rewards, store_id: store_hash })

}

loyaltyInit();
